import React from 'react';
import './Skeleton.css';

// Generic shimmer block — the building block for every loading state in the
// redesigned student UI. Before this, only StudentPortal had any spinner at
// all; every other page just rendered a plain "Loading..." string. Use this
// instead of introducing a new per-page loading pattern.
export const Skeleton = ({ width = '100%', height = 16, radius = 8, style, className = '' }) => (
  <span
    className={`z-skel ${className}`}
    style={{ width, height, borderRadius: radius, ...style }}
    aria-hidden="true"
  />
);

// A card-shaped skeleton matching the standard .z-card footprint — for
// "this whole card hasn't loaded yet" states.
export const SkeletonCard = ({ lines = 3, height = 'auto', className = '' }) => (
  <div className={`z-card z-skel-card ${className}`} style={{ height }} role="status" aria-label="Loading">
    <Skeleton width="40%" height={14} style={{ marginBottom: 12 }} />
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} width={i === lines - 1 ? '60%' : '100%'} height={12} style={{ marginBottom: 8 }} />
    ))}
  </div>
);

// A readiness-hero-shaped skeleton (ring + a couple of lines) — used on Home
// while the dashboard payload is in flight.
export const SkeletonHero = () => (
  <div className="z-card z-skel-hero" role="status" aria-label="Loading readiness">
    <Skeleton width={96} height={96} radius={999} />
    <div style={{ flex: 1 }}>
      <Skeleton width="50%" height={20} style={{ marginBottom: 10 }} />
      <Skeleton width="80%" height={13} style={{ marginBottom: 8 }} />
      <Skeleton width="65%" height={13} />
    </div>
  </div>
);

export default Skeleton;
